<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main" v-infinite-scroll="load" infinite-scroll-delay="200" infinite-scroll-distance="200">
        <SubTitleComponent :title="title"></SubTitleComponent>
        <div class="box">
          <div class="filter">
            <el-row :gutter="10">
              <el-col :span="3">
                <h4>我的客户</h4>
              </el-col>
              <el-col :span="6">
                <div class="grid-content">
                  <el-input
                    placeholder="请输入内容"
                    prefix-icon="el-icon-search"
                    @change="onChange"
                    v-model="searchInput">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="4" :offset="6"><el-button icon="el-icon-circle-plus-outline" type="success" @click="toNew"><span class="btn">创建新客户</span></el-button></el-col>
              <el-col :span="5"><el-button icon="el-icon-right" type="success" @click="toHistory"><span class="btn">查看历史客户</span></el-button></el-col>
            </el-row>
          </div>
          <ul v-if="customerData.length > 0" class="list" style="overflow:auto">
            <li v-for="item in customerData" :key="'customer' + item.client_id" class="item">
              <div class="id">{{ item.number }}</div>
              <div class="name">{{ item.client_name }}</div>
              <div class="info"><span>{{ item.city_name }}</span><span>{{ item.industry_type }}</span><span>{{ item.project_type }}</span><span>{{ item.project_area }}m²</span></div>
              <div class="date">{{ item.date }}</div>
              <el-button class="detail" size="mini" type="success" @click="toDetail(item.client_id)">查看详情</el-button>
            </li>
          </ul>
          <div class="list" v-if="customerData.length <= 0">
            <el-empty description="暂无数据"></el-empty>
          </div>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>
  
<script>
let _ajaxType = 0

export default {
  name: 'Index',
  components: {},
  data() {
    return {
      title: '',
      searchInput: '',
      customerData: [],
      page: 0,
      pagesize: 10,
      allpage: 0
    }
  },
  mounted() {
    this.page = 0
    this.allpage = 0
    this.customerData = []
    console.log("load")
    _ajaxType = 0
    this.load()
  },
  methods: {
    load () {
      this.getData()
    },
    getData() {
      if(_ajaxType == 1) return
      let _page = this.page
      let _allpage = this.allpage
      console.log(_page, _allpage)
      if(_allpage <= 0 || _page < _allpage){
        _ajaxType = 1
        let _url = "/api/?mod=client"
        let _clientData = {
          page: _page + 1,
          pagesize: this.pagesize,
          keyword: this.searchInput
        }
        // console.log(this.axios)
        this.axios.post(_url, _clientData).then(json => {
          // 获取
          _ajaxType = 0
          let _data = json.data.data
          console.log("clientData", _data);
          if (json.data.errcode == 0) {
            this.page = _data.page
            this.allpage = _data.allpage
            this.customerData = [...this.customerData, ..._data.result]
          }
          console.log(json.data);
        })
      }
    },
    toDetail(id) {
      this.$router.push({ path: '/customerdetail/' + id })
    },
    toHistory() {
      this.$router.push({ path: '/customerhistory' })
    },
    toNew() {
      this.$router.push({ path: '/customernew' })
    },
    onChange(e) {
      console.log('searchChange', e)
      this.customerData = []
      this.page = 0
      this.allpage = 0
      this.getData()
    }
  }
}
</script>
  
<style scoped lang="less">
.header {
  z-index: 1001;
}
.main {
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 6px;
  .box {
    min-height: calc(100vh - 154px);
    padding: 0 20px 20px;
    // background: #fff;
    box-sizing: border-box;
    .filter {
      padding: 10px;
      margin-bottom: 20px;
      background: #fff;
      h4 {
        // margin-bottom: 8px;
        // padding-left: 12px;
        color: rgb(16, 16, 16);
        font-size: 20px;
        font-weight: 400;
        line-height: 2em;
      }
      .el-button {
        width: 100%;
      }
    }
    ul.list {
      display: grid;
      // flex-wrap: wrap;
      // justify-content: space-between;
      grid-template-columns: repeat(3, 1fr);
      padding-inline-start: 0;
      gap: 20px;
      // padding: 0 30px;
      vertical-align: top;
      list-style: none;
      li {
        position: relative;
        // flex: 0 0 calc(30%);
        gap: 20px;
        padding: 5px 10px 10px;
        background: #fff;
        border: 1px solid rgb(187, 187, 187);
        border-radius: 2px;
        box-sizing: border-box;
        .id {
          color: rgba(101,103,104,1);
          font-size: 12px;
          text-align: right;
          line-height: 24px;
        }
        .name {
          padding-left: 24px;
          background: url(../assets/ico_person.png) no-repeat;
          background-size: auto 18px;
          background-position: 0 center;
          color: rgba(10,10,10,1);
          font-size: 18px;
          line-height: 36px;
        }
        .info {
          min-height: 48px;
          margin-bottom: 12px;
          vertical-align: top;
          font-size: 0;
          span {
            display: inline-block;
            margin-right: 15px;
            color: rgba(101,103,104,1);
            font-size: 12px;
            font-weight: 300;
            line-height: 24px;
          }
        }
        .date {
          color: rgba(101,103,104,1);
          font-size: 12px;
          line-height: 24px;
        }
        .detail {
          position: absolute;
          bottom: 10px;
          right: 10px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index.vue